import React from 'react';
import './GrayCard.css';
import _isEmpty from 'lodash/isEmpty';
import _isEqual from 'lodash/isEqual';
import { Link } from 'react-router-dom';
import {OverlayTrigger, Tooltip } from 'react-bootstrap';

class GrayCard extends React.Component {
    state={
    }
    renderTitle() {
        if (this.props.type === "amount") {
            return (
                <div className=""> <span className="">{this.props.amount}</span></div>
            )
        } else if (this.props.type === "items") {
            return (
                <div className=""> <span className="">{this.props.items} (Items)</span></div>
            )

        }
    }

    renderArrow() {
        if(isNaN(Number(this.props.growthAmount))){
       
            return (<div >NA</div>
            );
        }
        if (this.props.growth === "positive") {
            return <div>{Number(this.props.growthAmount).toFixed(2)} <Link className = "success"><i className="fas fa-arrow-circle-up"></i></Link></div>

        } else if (this.props.growth === "negative") {
            return <div>{Number(this.props.growthAmount).toFixed(2)} <Link className = "danger"><i className="fas fa-arrow-circle-down"></i></Link> </div>
            
        }
    }

    renderDate() {
        if(this.props.updatedDate != null){
            return (<div >{this.props.updatedDate}</div>
                );
        }
        else{
            return (<div >NA</div>
                );
        }
    }

    displayModalForRebate(){
        let propsForModal={
            title:this.props.title,
            purchaseAmount:this.props.purchaseAmount,
            rebateInfo : this.props.rebateInfo

        }
        this.props.displayModal(propsForModal);
    }

    displayModal(){
        let propsForModal={
            title:this.props.title,
            amount:this.props.amount,
            items:this.props.items,
            type:this.props.type,
            date:this.props.date,
            growthAmount:this.props.growthAmount,
            growth:this.props.growth,
            excessRevenue:this.props.excessRevenue

        }
        this.props.displayModal(propsForModal);
    }
	
	renderDate() {
        if(this.props.updatedDate != null){
            return (<div >{this.props.updatedDate}</div>
                );
        }
        else{
            return (<div >NA</div>
                );
        }
    }

    renderRebateCard=()=>{
        console.log(this.props);
        return(
            <div className="col-sm-3 ">
                 <OverlayTrigger overlay={(<Tooltip id="callModal"> {this.props.title} </Tooltip>)} popperConfig={{ modifiers: { preventOverflow: { boundariesElement: 'viewport' } } }} placement="down">
                
            <div className=" grayCards panel panel-card" >
                <div className="panel-body">
                    <div className="panel-title minHeightTitle"><span>{this.props.title} </span></div>
                    <div className="">
                        <div >
                           Purchase Amount : {this.props.purchaseAmount}
                        </div>
                    </div>
                </div>
                <div className="panel-footer">
                    <span>Click here for Rebate information</span>
                </div>
            </div>
            </OverlayTrigger>
        </div>
        )
    }
    renderExcessCard=()=>{
        console.log(this.props);
        return(
            <div className="col-sm-3 ">
               <OverlayTrigger overlay={(<Tooltip id="callModal">Total {this.props.title} From IMARK Verified Data</Tooltip>)} popperConfig={{ modifiers: { preventOverflow: { boundariesElement: 'viewport' } } }} placement="down">
                
            <div className=" grayCards panel panel-card" style={{height:"126px"}}>
                <div className="panel-body">
                    <div className="panel-title minHeightTitle"><span>{this.props.title} </span></div>
                    <div className="">
                        <div >
                         <div style={{fontSize:"25px"}}>{this.props.excessRevenue}</div>
                        </div>
                    </div>
                </div>
                <div className="panel-footer"></div>
            </div>
            </OverlayTrigger>
        </div>
        )
    }
    renderTitleIfRebateFilteredOrNot(){
        
            if(this.props.title.substring(2,0)==="BH" || this.props.title.substring(2,0)==="Bh"){
                return (
                    <div className="panel-title minHeightTitle" style={{color:"#00bcd4"}}><span>{this.props.title} </span></div>
                )
            }
            else if (this.props.title==="Member Purchases"){
                return (
                    <div className="panel-title minHeightTitle"><span>Member Total Purchases</span></div>
                )
            }
            else if (this.props.title === "Estimated Growth Rebate"){
                return (
                    <div className="panel-title minHeightTitle"><span>Estimated Group Growth Rebate</span></div>
                )
            }
            return (
                <div className="panel-title minHeightTitle"><span>{this.props.title} </span></div>
            )
        
    }
    render() {
        const { show } = this.props;
        if(this.props.type==="rebateCard"){
            return this.renderRebateCard()
        }
        if(this.props.title==="Excess Revenue Points"){
            return this.renderExcessCard()
        }
        if(this.props.title==="Member Purchases"){
        return (
            <div className="col-sm-4 ">
                  <OverlayTrigger overlay={(<Tooltip id="callModal">Total Member Sales for IMARK vendors including rebatable and non-rebatable sales

</Tooltip>)} popperConfig={{ modifiers: { preventOverflow: { boundariesElement: 'viewport' } } }} placement="down">
               
                <div className=" grayCards panel panel-card">
                    <div className="panel-main">
                       {this.renderTitleIfRebateFilteredOrNot()}
                        <div className="panel-value">
                            
                                {/* will print $ or items based on type */}
                                {this.renderTitle()}
                         
                        </div>
                    </div>
					{ this.props.updatedDate != null ?
                    <React.Fragment>
                    <hr/>
                    <div className="panel-footer">
                        <div className="updatedOn"><span style={{marginRight:"5px"}}>Last Updated Date</span></div>
                        <div className="figures">
                            {this.renderDate()}
                        </div>
                
                    </div>
                    </React.Fragment> : ""
    }
                    <hr/>
                    <div className="panel-footer">
                        <div className="yoy"><span style={{marginRight:"5px"}}>YOY</span></div>
                        <div className="figures">
                            {this.renderArrow()}
                        </div>
                
                    </div>
                    
                </div>
                </OverlayTrigger>
            </div>
        )
    }
    if(this.props.title ==="Total Rebate Estimate"){
        return ( ""
        // Commented on 01/04/2020 as this card is not required any more in dashboard
    //         <div className="col-sm-3 ">
    //               <OverlayTrigger overlay={(<Tooltip id="callModal">Total Estimated Rebate Based On Your Reported Purchases</Tooltip>)} popperConfig={{ modifiers: { preventOverflow: { boundariesElement: 'viewport' } } }} placement="down">
               
    //             <div className=" grayCards panel panel-card" >
    //                 <div className="panel-main">
    //                    {this.renderTitleIfRebateFilteredOrNot()}
    //                     <div className="panel-value">
                            
    //                             {/* will print $ or items based on type */}
    //                             {this.renderTitle()}
                         
    //                     </div>
    //                 </div>
	// 				{ this.props.updatedDate != null ?
    //                 <React.Fragment>
    //                 <hr/>
    //                 <div className="panel-footer">
    //                     <div className="updatedOn"><span style={{marginRight:"5px"}}>Last Updated Date</span></div>
    //                     <div className="figures">
    //                         {this.renderDate()}
    //                     </div>
                
    //                 </div>
    //                 </React.Fragment> : ""
    // }
    //                 <hr/>
    //                 <div className="panel-footer">
    //                     <div className="yoy"><span style={{marginRight:"5px"}}>YOY</span></div>
    //                     <div className="figures">
    //                         {this.renderArrow()}
    //                     </div>
                
    //                 </div>
                    
    //             </div>
    //             </OverlayTrigger>
    //         </div>
        )
    }
    if(this.props.title==="Potential Purchase"){
        return (
            <div className="col-sm-4 ">
                  <OverlayTrigger overlay={(<Tooltip id="callModal">High probability purchase opportunity</Tooltip>)} popperConfig={{ modifiers: { preventOverflow: { boundariesElement: 'viewport' } } }} placement="down">
               
                <div className=" grayCards panel panel-card" >
                    <div className="panel-main">
                       {this.renderTitleIfRebateFilteredOrNot()}
                        <div className="panel-value">
                            
                                {/* will print $ or items based on type */}
                                {this.renderTitle()}
                         
                        </div>
                    </div>
					{ this.props.updatedDate != null ?
                    <React.Fragment>
                    <hr/>
                    <div className="panel-footer">
                        <div className="updatedOn"><span style={{marginRight:"5px"}}>Last Updated Date</span></div>
                        <div className="figures">
                            {this.renderDate()}
                        </div>
                
                    </div>
                    </React.Fragment> : ""
    }
                    <hr/>
                    <div className="panel-footer">
                        <div className="yoy"><span style={{marginRight:"5px"}}>YOY</span></div>
                        <div className="figures">
                            {this.renderArrow()}
                        </div>
                
                    </div>
                    
                </div>
                </OverlayTrigger>
            </div>
        )
    }
    if(this.props.title==="Base Rebate"){
        return (""
                // Commented on 01/04/2020 as this card is not required any more in dashboard

    //         <div className="col-sm-3 ">
    //               <OverlayTrigger overlay={(<Tooltip id="callModal">Base Rebate Estimated Based On Your Reported Purchases</Tooltip>)} popperConfig={{ modifiers: { preventOverflow: { boundariesElement: 'viewport' } } }} placement="down">
               
    //             <div className=" grayCards panel panel-card" >
    //                 <div className="panel-main">
    //                    {this.renderTitleIfRebateFilteredOrNot()}
    //                     <div className="panel-value">
                            
    //                             {/* will print $ or items based on type */}
    //                             {this.renderTitle()}
                         
    //                     </div>
    //                 </div>
	// 				{ this.props.updatedDate != null ?
    //                 <React.Fragment>
    //                 <hr/>
    //                 <div className="panel-footer">
    //                     <div className="updatedOn"><span style={{marginRight:"5px"}}>Last Updated Date</span></div>
    //                     <div className="figures">
    //                         {this.renderDate()}
    //                     </div>
                
    //                 </div>
    //                 </React.Fragment> : ""
    // }
    //                 <hr/>
    //                 <div className="panel-footer">
    //                     <div className="yoy"><span style={{marginRight:"5px"}}>YOY</span></div>
    //                     <div className="figures">
    //                         {this.renderArrow()}
    //                     </div>
                
    //                 </div>
                    
    //             </div>
    //             </OverlayTrigger>
    //         </div>
        )
    }
    if(this.props.title==="FBI Rebate"){
        return (""
                // Commented on 01/04/2020 as this card is not required any more in dashboard

    //         <div className="col-sm-3 ">
    //               <OverlayTrigger overlay={(<Tooltip id="callModal">Base Rebate Estimated Based On Your Reported Purchases</Tooltip>)} popperConfig={{ modifiers: { preventOverflow: { boundariesElement: 'viewport' } } }} placement="down">
               
    //             <div className=" grayCards panel panel-card"  data-toggle="tooltip" title={this.props.title}>
    //                 <div className="panel-main">
    //                    {this.renderTitleIfRebateFilteredOrNot()}
    //                     <div className="panel-value">
                            
    //                             {/* will print $ or items based on type */}
    //                             {this.renderTitle()}
                         
    //                     </div>
    //                 </div>
	// 				{ this.props.updatedDate != null ?
    //                 <React.Fragment>
    //                 <hr/>
    //                 <div className="panel-footer">
    //                     <div className="updatedOn"><span style={{marginRight:"5px"}}>Last Updated Date</span></div>
    //                     <div className="figures">
    //                         {this.renderDate()}
    //                     </div>
                
    //                 </div>
    //                 </React.Fragment> : ""
    // }
    //                 <hr/>
    //                 <div className="panel-footer">
    //                     <div className="yoy"><span style={{marginRight:"5px"}}>YOY</span></div>
    //                     <div className="figures">
    //                         {this.renderArrow()}
    //                     </div>
                
    //                 </div>
                    
    //             </div>
    //             </OverlayTrigger>
    //         </div>
            
        )
    }
    if(this.props.title==="Missed Rebate Opportunity"){
        return (
            <div className="col-sm-4 ">
                  <OverlayTrigger overlay={(<Tooltip id="callModal">Rebate You Missed</Tooltip>)} popperConfig={{ modifiers: { preventOverflow: { boundariesElement: 'viewport' } } }} placement="down">
               
                <div className=" grayCards panel panel-card"  data-toggle="tooltip" title={this.props.title}>
                    <div className="panel-main">
                       {this.renderTitleIfRebateFilteredOrNot()}
                        <div className="panel-value">
                            
                                {/* will print $ or items based on type */}
                                {this.renderTitle()}
                         
                        </div>
                    </div>
					{ this.props.updatedDate != null ?
                    <React.Fragment>
                    <hr/>
                    <div className="panel-footer">
                        <div className="updatedOn"><span style={{marginRight:"5px"}}>Last Updated Date</span></div>
                        <div className="figures">
                            {this.renderDate()}
                        </div>
                
                    </div>
                    </React.Fragment> : ""
    }
                    <hr/>
                    <div className="panel-footer">
                        <div className="yoy"><span style={{marginRight:"5px"}}>YOY</span></div>
                        <div className="figures">
                            {this.renderArrow()}
                        </div>
                
                    </div>
                    
                </div>
                </OverlayTrigger>
            </div>
        )
    }
    if(this.props.title==="Total Rebate"){
        return (
            <div className="col-sm-4 ">
                  <OverlayTrigger overlay={(<Tooltip id="callModal">{this.props.title} From IMERK Verified Data</Tooltip>)} popperConfig={{ modifiers: { preventOverflow: { boundariesElement: 'viewport' } } }} placement="down">
               
                <div className=" grayCards panel panel-card"  data-toggle="tooltip" title={this.props.title}>
                    <div className="panel-main">
                       {this.renderTitleIfRebateFilteredOrNot()}
                        <div className="panel-value">
                            
                                {/* will print $ or items based on type */}
                                {this.renderTitle()}
                         
                        </div>
                    </div>
					{ this.props.updatedDate != null ?
                    <React.Fragment>
                    <hr/>
                    <div className="panel-footer">
                        <div className="updatedOn"><span style={{marginRight:"5px"}}>Last Updated Date</span></div>
                        <div className="figures">
                            {this.renderDate()}
                        </div>
                
                    </div>
                    </React.Fragment> : ""
    }
                    <hr/>
                    <div className="panel-footer">
                        <div className="yoy"><span style={{marginRight:"5px"}}>YOY</span></div>
                        <div className="figures">
                            {this.renderArrow()}
                        </div>
                
                    </div>
                    
                </div>
                </OverlayTrigger>
            </div>
        )
    }
        return (
            <div className="col-sm-4 ">
                  <OverlayTrigger overlay={(<Tooltip id="callModal">{this.props.title} From IMARK Verified Data</Tooltip>)} popperConfig={{ modifiers: { preventOverflow: { boundariesElement: 'viewport' } } }} placement="down">
               
                <div className=" grayCards panel panel-card"  data-toggle="tooltip" title={this.props.title}>
                    <div className="panel-main">
                       {this.renderTitleIfRebateFilteredOrNot()}
                        <div className="panel-value">
                            
                                {/* will print $ or items based on type */}
                                {this.renderTitle()}
                         
                        </div>
                    </div>
					{ this.props.updatedDate != null ?
                    <React.Fragment>
                    <hr/>
                    <div className="panel-footer">
                        <div className="updatedOn"><span style={{marginRight:"5px"}}>Last Updated Date</span></div>
                        <div className="figures">
                            {this.renderDate()}
                        </div>
                
                    </div>
                    </React.Fragment> : ""
    }
                    <hr/>
                    <div className="panel-footer">
                        <div className="yoy"><span style={{marginRight:"5px"}}>YOY</span></div>
                        <div className="figures">
                            {this.renderArrow()}
                        </div>
                
                    </div>
                    
                </div>
                </OverlayTrigger>
            </div>
        )
    }

    
}

export default GrayCard;